import { omit, isArray, isObject } from 'lodash';

/**
 * Recursively deletes the specified property from the given object and all of its nested objects.
 * @param object The object to delete the property from.
 * @param property The property to delete.
 * @returns A copy of the object with the property removed.
 */
export const omitDeep = (obj, keys) => {
  if (isArray(obj)) {
    return obj.map((item) => omitDeep(item, keys));
  } else if (isObject(obj)) {
    const newObj = omit(obj, keys);
    Object.keys(newObj).forEach((key) => {
      newObj[key] = omitDeep(newObj[key], keys);
    });
    return newObj;
  }
  return obj;
};
